import {
  combineReducers,
  createSlice,
  createAsyncThunk,
} from "@reduxjs/toolkit";

import proposalInformation from "./ProposalInformation";
import projectDetails from "./ProjectDetails";
import applicantInformation from "./ApplicantInformation";
import leadershipInformation from "./LeadershipInformation";
import experience from "./Experience";
import { IDeveloperApplicationState } from "../../service/DeveloperApplicationService";
import FirebaseDeveloperApplicationService from "../../service/Firebase/developerApplication";

const initialState = {
  createdID: "",
  opportunityInfo: {},
  preliminaryProgram: {},
  projectUses: {},
  projectSource: {},
  milestoneSchedule: {},
  projectTeam: {},
  vendor: {},
  incentives: {},
  submitting: false,
  submitSuccess: false,
  submitError: false,
  fetching: false,
  fetchSuccess: false,
  fetchError: false,
  deleting: false,
  deleteSuccess: false,
  deleteError: false,
  isLoggedIn: false,
};

export const submitDeveloperApplication = createAsyncThunk(
  "developer-application/submit",
  async (_, arg: any) => {
    const { developerApplication } = arg.getState();
    const {
      projectDetails,
      applicantInformation,
      leadershipInformation,
      experience,
    } = developerApplication;

    const srv = new FirebaseDeveloperApplicationService();

    const { id } = await srv.saveDeveloperApplication({
      projectDetails,
      applicantInformation,
      leadershipInformation,
      experience,
    });

    return { id };
  }
);

export const listDeveloperApplications = createAsyncThunk(
  "developerApplications/list",
  async (account: string) => {
    const srv = new FirebaseDeveloperApplicationService();
    const developerApplications = await srv.listDeveloperApplications(account);
    return developerApplications;
  }
);

const developerApplicationMainSlice = createSlice({
  name: "developerApplication",
  initialState: {
    ...initialState,
    developerApplications: [] as IDeveloperApplicationState[],
  },
  reducers: {
    clear: (state) => ({
      ...state,
      ...{
        submitting: false,
        submitSuccess: false,
        submitError: false,
        fetching: false,
        fetchSuccess: false,
        fetchError: false,
        deleting: false,
        deleteSuccess: false,
        deleteError: false,
      },
    }),
    setIsLoggedIn(state, { payload }) {
      state.isLoggedIn = payload;
    },
    setIsApplicationSubmitted(state, { payload }) {
      state.submitSuccess = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(submitDeveloperApplication.pending, (state, action) => {
      state.submitting = true;
    });
    builder.addCase(
      submitDeveloperApplication.fulfilled,
      (state, { payload }) => {
        state.submitSuccess = true;
        state.submitting = false;
      }
    );
    builder.addCase(submitDeveloperApplication.rejected, (state, { error }) => {
      console.log("submitDeveloperApplication.rejected", error);
      state.submitError = true;
      state.submitting = false;
    });
    builder.addCase(
      listDeveloperApplications.fulfilled,
      (state, { payload }) => {
        state.fetching = false;
        state.developerApplications = payload;
      }
    );
    builder.addCase(listDeveloperApplications.pending, (state, { payload }) => {
      state.fetching = true;
    });
    builder.addCase(listDeveloperApplications.rejected, (state, { error }) => {
      console.log("listDeveloperApplications.rejected", error);
      state.fetching = false;
      state.fetchError = true;
    });
  },
});

export const { clear, setIsLoggedIn, setIsApplicationSubmitted } =
  developerApplicationMainSlice.actions;

const developerApplicationReducer = combineReducers({
  proposalInformation,
  projectDetails,
  applicantInformation,
  leadershipInformation,
  experience,
  opportunityMain: developerApplicationMainSlice.reducer,
});

export default developerApplicationReducer;
